<script>
    import { getContext } from 'svelte';
    import MenuAdministrationMenuItem from "./MenuAdministrationMenuItem.svelte";
    import {decode} from "html-entities";

    const { open } = getContext('simple-modal');

    export let model_root;
    export let footer;

    let currentMenuItemData = {};
    let errorMsg = "";

    let menuItems = loadMenuItems();

    const showNewMenuItemTool = () => {
        currentMenuItemData = {
            mname: ""
        }
        openMenuDetailsModal();
    };

    function showNewSubMenuItemTool(parent) {
        currentMenuItemData = {
            mname: "",
            mparent: parent
        }
        openMenuDetailsModal();
    }

    function showEditMenuItemTool(id, name) {
        currentMenuItemData = {
            mid: id,
            mname: decode(name)
        }
        openMenuDetailsModal();
    }

    function openMenuDetailsModal() {
        open(MenuAdministrationMenuItem, {
            model_root: model_root,
            currentMenuItemData: currentMenuItemData,
            footer: footer
        }, {}, {
            onClosed: () => {
                reloadMenuItems()
            }
        });
    }

    function loadMenuItems() {
        return fetch(model_root + 'shared/menu/load_menu_items.php?footer='+footer, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function reloadMenuItems() {
        location.reload();
        //menuItems = loadMenuItems();
    }

    function moveItem(id, direction) {
        const data = new FormData();
        data.append("mid", id);
        data.append("direction", direction);

        fetch(model_root + 'admin/menu/move_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                (msg === "success") ? reloadMenuItems() : showErrorMsg(msg);
            });
    }

    function deleteMenuItem(id, name) {
        if (!confirm(`Soll der Menüpunkt "${name}" wirklich entfernt werden? Dies kann nicht rückgängig gemacht werden!`)) {
            return;
        }

        const data = new FormData();
        data.append("mid", id);

        fetch(model_root + 'admin/menu/delete_menu_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                (msg === "success") ? reloadMenuItems() : showErrorMsg(msg);
            });
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
        window.scrollTo(0, 0);
    }

    function hideErrorMsg() {
        errorMsg = "";
    }
</script>

<h4 class="text-muted">Seiteninhalte</h4>
<h2 class="mb-4">
    {#if footer == 0}
        Menü-Verwaltung
    {:else if footer == 1}
        Fußbereich (Footer) - Verwaltung
    {/if}
</h2>

{#if errorMsg.length > 0}
    <div class="alert alert-danger" role="alert">
        {errorMsg}
        <br>
        <a href="#" on:click={hideErrorMsg}>Fehlermeldung verbergen</a>
    </div>
{/if}

<ul class="list-group">
    {#await menuItems}
        <p class="text-center mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Menüelemente werden geladen...</p>
    {:then data}
        {#each data as item}
            {#if item.mparent === null}
                <li class="list-group-item pt-3 border-dark">
                    <b>{@html item.mname}</b>
                    <button on:click={() => {moveItem(item.mid, "down")}} class="btn btn-light float-end mx-1 sort-down" title="Eine Ebene nach unten"><i class="fas fa-angle-down"></i></button>
                    <button on:click={() => {moveItem(item.mid, "up")}} class="btn btn-light float-end mx-1 sort-up" title="Eine Ebene nach oben"><i class="fas fa-angle-up"></i></button>
                    <br>
                    <div class="menu-item-action">
                        <a class="text-dark" href="#" on:click={ () => showEditMenuItemTool(item.mid, item.mname) }>
                            <i class="far fa-edit"></i> Name ändern
                        </a>
                    </div>
                    {#if item.msystem === "0"}
                        <div class="menu-item-action">
                            <a class="text-dark" href="#" on:click={ () => deleteMenuItem(item.mid, item.mname) }>
                                <i class="far fa-trash-alt"></i> Löschen
                            </a>
                        </div>
                    {/if}

                    {#if footer == 0}
                        <ul class="list-group mt-3 mb-2 ms-4">
                            {#each data as subitem}
                                {#if subitem.mparent === item.mid}
                                    <li class="list-group-item">
                                        <b>{@html subitem.mname}</b>
                                        <button on:click={() => {moveItem(subitem.mid, "down")}}  class="btn btn-link text-dark float-end mx-1 mt-1 sort-down" title="Eine Ebene nach unten"><i class="fas fa-angle-down"></i></button>
                                        <button on:click={() => {moveItem(subitem.mid, "up")}}  class="btn btn-link text-dark float-end mx-1 mt-1 sort-up" title="Eine Ebene nach oben"><i class="fas fa-angle-up"></i></button>
                                        <br>
                                        <div class="menu-item-action">
                                            <a class="text-dark" href="#" on:click={ () => showEditMenuItemTool(subitem.mid, subitem.mname) }>
                                                <i class="far fa-edit"></i> Name ändern
                                            </a>
                                        </div>
                                        {#if subitem.msystem === "0"}
                                            <div class="menu-item-action">
                                                <a class="text-dark" href="#" on:click={ () => deleteMenuItem(subitem.mid, subitem.mname) }>
                                                    <i class="far fa-trash-alt"></i> Löschen
                                                </a>
                                            </div>
                                        {/if}

                                        {#if 1===0}
                                            <ul class="list-group mt-3 mb-2 ms-4">
                                                {#each data as subsubitem}
                                                    {#if subsubitem.mparent === subitem.mid}
                                                        <li class="list-group-item">
                                                            <b>{subsubitem.mname}</b>
                                                            <button on:click={() => {moveItem(subsubitem.mid, "down")}}  class="btn btn-link text-dark float-end mx-1 mt-1 sort-down" title="Eine Ebene nach unten"><i class="fas fa-angle-down"></i></button>
                                                            <button on:click={() => {moveItem(subsubitem.mid, "up")}}  class="btn btn-link text-dark float-end mx-1 mt-1 sort-up" title="Eine Ebene nach oben"><i class="fas fa-angle-up"></i></button>
                                                            <br>
                                                            <div class="menu-item-action">
                                                                <a class="text-dark" href="#" on:click={ () => showEditMenuItemTool(subsubitem.mid, subsubitem.mname) }>
                                                                    <i class="far fa-edit"></i> Name ändern
                                                                </a>
                                                            </div>
                                                            {#if subitem.msystem === "0"}
                                                                <div class="menu-item-action">
                                                                    <a class="text-dark" href="#" on:click={ () => deleteMenuItem(subsubitem.mid, subsubitem.mname) }>
                                                                        <i class="far fa-trash-alt"></i> Löschen
                                                                    </a>
                                                                </div>
                                                            {/if}                                                        </li>
                                                    {/if}
                                                {/each}
                                                <li class="list-group-item pt-3 pb-3 bg-light text-dark" role="button" on:click={ () => showNewSubMenuItemTool(subitem.mid) }>
                                                    <i class="fas fa-plus"></i>
                                                    Untermenü hinzufügen
                                                </li>
                                            </ul>
                                        {/if}

                                    </li>
                                {/if}
                            {/each}
                            <li class="list-group-item pt-3 pb-3 bg-light text-dark" role="button" on:click={ () => showNewSubMenuItemTool(item.mid) }>
                                <i class="fas fa-plus"></i>
                                Untermenü hinzufügen
                            </li>
                        </ul>
                    {/if}
                </li>
            {/if}
        {/each}
    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
    <li class="list-group-item pt-3 pb-3 bg-light text-dark border-dark" role="button" on:click={showNewMenuItemTool}>
        <i class="fas fa-plus"></i>
        Menüpunkt hinzufügen
    </li>
</ul>

<style>

    .menu-item-action {
        display: block;
        margin-top: 3px;
    }

    .menu-item-action i {
        width: 18px;
    }

    /*.list-group .list-group-item:first-child .sort-up {
        display: none;
    }

    .list-group .list-group-item:nth-last-child(2) .sort-down {
        display: none;
    }*/

</style>
